import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import ButtomCustom from "../../../ButtonRound";
import { confirmAlert } from "react-confirm-alert"; // Import
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import * as jose from 'jose'

import HttpClient from "../../../../helpers/HttpClient";
import { showToast } from "../../../../utils/toast";
import OverlayLoader from "../../../OverlayLoader";

import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";

import TranslateIcon from "@mui/icons-material/Translate";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AlertModal from "../../../Tests/components/AlertModal";
import FloatingIcon from "../AnimationResultAnswer";
import MobileStepper from "../MobileStepper";
import HelpIcon from "@mui/icons-material/Help";
import Grammar from "../../Grammar";
import Writing from "../../Writing";
import CreatingSentence from "../../CreatingSentence";
import ReadAndListenAnswer from "../../ReadAndListenAnswer";
import ListenAndSelectImage from "../../ListenAndSelectImage";
import PronunciationLesson from "../../Pronunciation";

const ExerciseContainer = ({
  courseCode,
  data,
  haveContainer = false,
  onFinalize,
  onContinue,
  numQuestionsForUse = 0,
  configPercentage,
  setResultForContainer,
  containerStepExcersiseType,
}) => {
  //const claims = jose.decodeJwt(token)
  //console.log(claims)
  const [openLoader, setOpenOpenLoader] = useState(false);
  const authState = useSelector((state) => state.auth);
  const userId =
    authState && authState.user ? authState.user.email : "test";
  const [questions, setQuestions] = useState([]);
  const [showCorrect, setShowCorrect] = useState(false);
  const [showInCorrect, setShowInCorrect] = useState(false);
  const [alert, setAlert] = useState({ visible: false, correct: false });
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [answers, setAnswers] = useState([]);
  const [isSaved, setIsSaved] = useState(false);
  const [exerciseType, setExerciseType] = useState(containerStepExcersiseType ? containerStepExcersiseType : data.tipo)
  const [modalProps, setModalProps] = useState({
    open: false,
    title: "Traducción",
    content: "",
    buttonText: "Aceptar",
  });
  const typesWithHelp = ["ESCRIBIR", "ESC_SEL_IMG"];

  const loadData = async () => {
    setOpenOpenLoader(true);
    let url = `/step/exercise-data/${userId}/${courseCode}/${exerciseType}/${data.cod_leccion}`
    if (["REVIEW","EVSU", "EVSM"].includes(data.tipo)) {
      url = `${url}/${data.cod_unidad}`
    }
    if (data.tipo == "EVSM") {
      url = `${url}/${courseCode}`
    }
    const request = await HttpClient().get(url
      //`/step/exercise-data/${userId}/ING1/GRAMATICA/ING1_0010_0040`
      //`/step/exercise-data/${userId}/ING1/ESCRIBIR/ING1_0010_0040`
      //`/step/exercise-data/${userId}/ING1/CREA_ORAC/ING1_0010_0040`

      //`/step/exercise-data/${userId}/ING1/LEER_ESC/ING1_0010_0040`
      //`/step/exercise-data/${userId}/ING1/IMG_SEL_RESP/ING1_0010_0040`
      //`/step/exercise-data/${userId}/ING1/ESC_SEL_FRA/ING1_0010_0040`

      //`/step/exercise-data/${userId}/ING1/ESC_SEL_IMG/ING1_0010_0040`
      //`/step/exercise-data/${userId}/ING1/VOC_PRA/ING1_0010_0040`

      //`/step/exercise-data/${userId}/ING1/PRONUNCIACION/ING1_0010_0040`

      
    );

    
    setOpenOpenLoader(false);
    if (request.error) {
      showToast("No se pudo cargar información. Intenta nuevamente.", "error");
      return;
    }
    console.log(request.data);
    //setQuestions(request.data.slice(0, 5));
    const questions = numQuestionsForUse > 0 ? request.data.slice(0, numQuestionsForUse) : request.data;
    setQuestions(questions);
    //setAnswers(Array(questions.length).fill(0));
  };

  const handleNext = () => {
    if (!selectedAnswer) {
      showToast("Debes completar la respuesta");
      return;
    }
    if (!showCorrect) return;

    setSelectedAnswer("");
    setCurrentQuestionIndex((prevIndex) =>
      Math.min(prevIndex + 1, questions.length - 1)
    );
    setShowCorrect(false);
    setShowInCorrect(false);
  };

  const handlePrevious = () => {
    setAnswers((prevAnswers) => {
      const newAnswers = [...prevAnswers];
      newAnswers[currentQuestionIndex] = selectedAnswer;
      return newAnswers;
    });
    setSelectedAnswer("");
    setCurrentQuestionIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const validateAnswer = () => {
    if (selectedAnswer && showCorrect) return false;
    const valueAnswer = parseInt(selectedAnswer.split("-")[1]);

    setShowCorrect(true);
    if (valueAnswer == 0) {
      setShowInCorrect(true);
    }
    setAnswers((prevAnswers) => {
      const newAnswers = [...prevAnswers];
      newAnswers[currentQuestionIndex] = valueAnswer;
      return newAnswers;
    });
    setAlert({ visible: true, correct: valueAnswer == 1 });
    setTimeout(() => {
      setAlert({ visible: false, correct: valueAnswer == 1 });
    }, 2000);
  };

  const handleChange = React.useCallback((newValue) => {
    setSelectedAnswer(newValue);
  }, []);

  const finalizeExercise = async () => {
    if (haveContainer) {
      const percentage = Math.round(
        (100 * answers.filter((ele) => ele == 1).length) / questions.length
      );
      setResultForContainer(percentage);
    } else {
      if (answers.length < questions.length) {
        confirmAlert({
          title: "¿Deseas guardar sin finalizar el ejercicio?",
          message:
            "Se omitirá cualquier avance. ¿Deseas continuar?",
          buttons: [
            {
              label: "Sí",
              onClick: async () => await execFinalizeExcercise(),
            },
            {
              label: "No",
              onClick: () => {},
            },
          ],
        });
      } else {
        await execFinalizeExcercise();
      }
    }
  };

  const execFinalizeExcercise = async () => {
    setOpenOpenLoader(true);
    const percentage = Math.round(
      (100 * answers.filter((ele) => ele == 1).length) / questions.length
    );
    const request = await HttpClient().post(
      `/step/exercise-result/${userId}/${courseCode}/${data.tipo}/${data.id}`,
      {
        percentage: percentage,
      }
    );
    setOpenOpenLoader(false);
    if (request.error) {
      showToast("No se pudo guardar el progreso. Intenta nuevamente.", "error");
      return;
    }
    setIsSaved(true);
    if (percentage >= configPercentage) {
      onFinalize();
    }
  };

  useEffect(() => {
    if (data) {
      setOpenOpenLoader(true);
      loadData();
      document.getElementsByClassName("main")[0].scrollTo({ top: 0, left: 0 });
      setOpenOpenLoader(false);
    }
  }, []);

  useEffect(()=>{
    const refreshQuiz  = async () => {
      if (haveContainer && answers && answers.length > 0) {
        finalizeExercise()
     }
    }
    refreshQuiz()
  }, [answers])

  return (
    <Grid
      container
      columns={{ xs: 4, md: 12 }}
      sx={{
        maxWidth: "900px",
        margin: "auto",
        mt: 3,
        p: 3,
        //borderRadius: 2,
        //boxShadow: 3,
        backgroundColor: "#fff",
        padding: "10px 10px 10px 10px",
      }}
    >
      <OverlayLoader open={openLoader} />
      <Grid container spacing={2}>
        {questions.length > 0 ? (
          <>
            <Card sx={{ marginBottom: 2, width: "100%" }}>
              <CardHeader
                sx={{ display: "" }}
                avatar={<Avatar>{data.nombre.split("")[0]}</Avatar>}
                action={
                  <Stack direction="row" spacing={1}>
                    <Chip
                      label={currentQuestionIndex + 1 + "/" + questions.length}
                      component="a"
                      clickable={false}
                    />
                    {questions[currentQuestionIndex].traduccion ? (
                      <Tooltip title="Ver traducción">
                        <IconButton
                          onClick={() => {
                            setModalProps({
                              ...modalProps,
                              title: "Traducción",
                              content:
                                questions[currentQuestionIndex].traduccion,
                              open: true,
                            });
                          }}
                          color="secondary"
                        >
                          <TranslateIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {questions[currentQuestionIndex].frase &&
                    typesWithHelp.includes(exerciseType) ? (
                      <Tooltip title="Ayuda">
                        <IconButton
                          onClick={() => {
                            setModalProps({
                              ...modalProps,
                              title: "Ayuda",
                              content: questions[currentQuestionIndex].frase,
                              open: true,
                            });
                          }}
                          color="secondary"
                        >
                          <HelpIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </Stack>
                }
                title={data.contenido}
                subheader={data.nombre}
              />

              {/*children*/}

              {questions.length && questions.length > 0 ? (
                <>
                  {exerciseType == "GRAMATICA" ? (
                    <Grammar
                      question={questions[currentQuestionIndex]}
                      selectedAnswer={selectedAnswer}
                      setAnswer={handleChange}
                      showCorrect={showCorrect}
                      showInCorrect={showInCorrect}
                      key={"grammar" + questions[currentQuestionIndex].id}
                      courseCode={courseCode}
                    />
                  ) : null}

                  {exerciseType == "ESCRIBIR" ? (
                    <Writing
                      question={questions[currentQuestionIndex]}
                      setAnswer={handleChange}
                      key={"writing" + questions[currentQuestionIndex].id}
                      courseCode={courseCode}
                    />
                  ) : null}

                  {exerciseType == "CREA_ORAC" ? (
                    <CreatingSentence
                      question={questions[currentQuestionIndex]}
                      showInCorrect={showInCorrect}
                      key={"sentence" + questions[currentQuestionIndex].id}
                      setAnswer={handleChange}
                      courseCode={courseCode}
                    />
                  ) : null}

                  {["LEER_ESC", "IMG_SEL_RESP", "ESC_SEL_FRA"].includes(
                    exerciseType
                  ) ? (
                    <ReadAndListenAnswer
                      question={questions[currentQuestionIndex]}
                      selectedAnswer={selectedAnswer}
                      setAnswer={handleChange}
                      showCorrect={showCorrect}
                      showInCorrect={showInCorrect}
                      showPhare={exerciseType == "LEER_ESC" ? true : false}
                      key={
                        "readlistenanswer" + questions[currentQuestionIndex].id
                      }
                      courseCode={courseCode}
                    />
                  ) : null}

                  {["ESC_SEL_IMG", "VOC_PRA"].includes(exerciseType) ? (
                    <ListenAndSelectImage
                      showPhare={exerciseType == "VOC_PRA" ? true : false}
                      question={questions[currentQuestionIndex]}
                      selectedAnswer={selectedAnswer}
                      setAnswer={handleChange}
                      showCorrect={showCorrect}
                      showInCorrect={showInCorrect}
                      key={"gramar" + questions[currentQuestionIndex].id}
                      courseCode={courseCode}
                    />
                  ) : null}

                  {exerciseType == "PRONUNC" ? (
                    <PronunciationLesson
                      question={questions[currentQuestionIndex]}
                      key={"pron" + questions[currentQuestionIndex].id}
                      setAnswer={handleChange}
                      courseCode={courseCode}
                    />
                  ) : null}
                </>
              ) : null}

              {/*<Writing 
                question={questions[currentQuestionIndex]} 
                setAnswer={handleChange}
                key={questions[currentQuestionIndex].id}
            />*/}
              {/*<Grammar
                question={questions[currentQuestionIndex]}
                selectedAnswer={selectedAnswer} 
                setAnswer={handleChange} 
                showCorrect= {showCorrect} 
                showInCorrect={showInCorrect}
                key={"gramar" + questions[currentQuestionIndex].id}
                />*/}

              {/*<CreatingSentence 
                question={questions[currentQuestionIndex]} 
                showInCorrect={showInCorrect}
                key={"sentence" + questions[currentQuestionIndex].id}
                setAnswer={handleChange}
            />*/}

              {/*<ReadAndListenAnswer 
            question={questions[currentQuestionIndex]}
            selectedAnswer={selectedAnswer} 
            setAnswer={handleChange} 
            showCorrect= {showCorrect} 
            showInCorrect={showInCorrect}
            showPhare={false}
            key={"gramar" + questions[currentQuestionIndex].id}
            />*/}

              {/*<ListenAndSelectImage

                question={questions[currentQuestionIndex]}
                selectedAnswer={selectedAnswer} 
                setAnswer={handleChange} 
                showCorrect= {showCorrect} 
                showInCorrect={showInCorrect}
                key={"gramar" + questions[currentQuestionIndex].id}

                />*/}

              {/*<PronunciationLesson 
                 question={questions[currentQuestionIndex]}
                 key={"pron" + questions[currentQuestionIndex].id}
                 setAnswer={handleChange} 
                />*/}

              <Grid
                item
                xs={12}
                sx={{ marginBottom: 2 }}
                className="lessons-button-container-center"
              >
                <ButtomCustom
                  variant="contained"
                  disabled={selectedAnswer ? false : true}
                  onClick={validateAnswer}
                  rounded
                >
                  Aceptar
                </ButtomCustom>
              </Grid>
            </Card>

            <Grid
              item
              xs={12}
              sx={{ marginTop: 12 }}
              style={{ margin: "auto" }}
            >
              {questions.length > answers.length ? (
                <MobileStepper
                  steps={questions.length}
                  activeStep={currentQuestionIndex}
                  disabledPrevious={true}
                  disabledNext={currentQuestionIndex === questions.length - 1}
                  handlePrevious={handlePrevious}
                  handleNext={handleNext}
                  previousText={"Atrás"}
                  nextText={"Siguiente"}
                />
              ) : null}
              {!isSaved && !haveContainer? (
                <ButtomCustom
                  className="lessons-button-container-center"
                  variant="outlined"
                  sx={{ float: "right" }}
                  onClick={finalizeExercise}
                  rounded
                  startIcon={<CloudUploadIcon />}
                >
                  Finalizar
                </ButtomCustom>
              ) : null}
            </Grid>

            <AlertModal
              open={modalProps.open}
              title={modalProps.title}
              content={modalProps.content}
              buttonText={modalProps.buttonText}
              onButtonClick={() => {
                setModalProps({
                  ...modalProps,
                  title: "",
                  content: "",
                  open: false,
                });
              }}
            />
          </>
        ) : null}
      </Grid>
      <FloatingIcon visible={alert.visible} correct={alert.correct} />
      {isSaved ? (
        <Grid item xs={12} className="lessons-button-container-center">
          <ButtomCustom
            sx={{ marginTop: 1 }}
            onClick={() => {
              onContinue();
            }}
            variant="contained"
            rounded
          >
            Continuar
          </ButtomCustom>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default ExerciseContainer;
